// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K3sv","placeholdersHeader":"styles_placeholdersHeader__-gom8","editorStyle":"styles_editorStyle__2ECNR","placeholdersBox":"styles_placeholdersBox__2ePQW"};